import assetPath from '/app/packages/lebenslauf/components/src/assets/prompt-regular.ttf';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')